import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrderDeliveryProcessView } from "src/components/views/erp/sales/orderDeliveryProcessView/OrderDeliveryProcessView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/orderDeliveryProcessView")({
	staticData: { title: i18n.t("order_delivery_process_view"), legacyViewKey: "orderDeliveryProcessViewPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <OrderDeliveryProcessView />;
}
